import useIntegrations from './hooks/useIntegrations';
import IntegrationsView from './view';

export default function Integrations({ info, setPageActions }) {
    const props = useIntegrations(info, setPageActions);
    return <IntegrationsView {...props} />;
}
